import React, { useEffect, useState } from "react";
import {
  FaFileAlt,
  FaDownload,
  FaQuestionCircle,
  FaTruckMoving,
} from "react-icons/fa";
import { MdExpandMore, MdExpandLess } from "react-icons/md";
import AdvertiserBarBehavioral from "./AdvertiserBarBehavioral";
import AdvertiserBarImpression from "./AdvertiserBarImpression";
import AdvertiserBarMiles from "./AdvertiserBarMiles";
import AdvertiserDonutEthnicities from "./AdvertiserDonutEthnicities";
import AdvertiserDonutIncomeLevel from "./AdvertiserDonutIncomeLevel";
import useApi from "../../hooks/useApi";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";

export default () => {
  const [data, setData] = useState({
    section1: true,
    section2: true,
    section3: true,
    section4: true,
    section5: true,
  });
  function handleChange(key, value) {
    setData({ ...data, [key]: value });
  }

  const [advertise, setAdvertise] = useState();
  const [compaignType, setCompaignType] = useState("Request Type");
  console.log(advertise, compaignType, "test");
  const handleMessage = () => {
    const message = document.getElementById("message");
    const listener = (e) => {
      setAdvertise({
        ...advertise,
        message: e.target.value,
      });
    };
    message.addEventListener("input", listener);
    return () => message.removeEventListener("input", listener);
  };
  const handlecomapignType = (value) => {
    console.log(value);
    setCompaignType(value);
  };
  const { request, loading, error } = useApi((submitData) =>
    apiClient.post("/advertiserCompaign", submitData)
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    alert("work");
    let submitData = {
      message: advertise.message,
      campaign_type: compaignType,
    };
    console.log(submitData, "sub");
    const result = await request(submitData);
    if (!result.status === 200) {
      return toast.error("Error");
    } else {
      return toast.success("Account Successfully Created");
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="site-content h-100">
          <div className="p-4">
            <div className="site-content-body">
              {/*-----------------------------
    Start || coporate section
    ----------------------------- */}
              <section className="corporate-sec">
                <div className="container">
                  {/* ==============Production-status============= */}
                  <div>
                    <div className="d-flex align-items-center justify-content-between">
                      <div />
                      <h4 className="blue-txt text-center position-relative prod-head">
                        Production Status
                      </h4>
                      <div>
                        {!data.section1 ? (
                          <MdExpandMore
                            size={40}
                            onClick={() => handleChange("section1", true)}
                          />
                        ) : (
                          <MdExpandLess
                            size={40}
                            onClick={() => handleChange("section1", false)}
                          />
                        )}
                      </div>
                    </div>
                    {/* --------btn-grp------ */}
                    {data.section1 && (
                      <div className="mt-2 bg-white rounded-3 border border-secondary px-3 py-2">
                        {/* <div className='test d-flex justify-content-end'>
                        <hr style={{width:"30%"}} />
                      </div> */}
                        <div className=" d-flex justify-content-end">
                        <div className=" col-5 d-none d-md-block">
                        <img className="img-fluid"
                          src={require("../../assets/img/''for-Statis-advertisement''.png")}
                          alt="img"
                          // style={{ width: "100%", height: "auto" }}
                        />
                      </div>
                        </div>
                        <div
                          className="d-flex overflow-auto border border-secondary my-grp-btn "
                          style={{ color: "#005E9D" }}
                        >
                          <button className="d-block bs-lh px-xl-1 px-xxl-3 py-2 border border-secondary text-light bg-myblue">
                            Awaiting Artwork
                          </button>
                          <button className="d-block bs-lh px-xl-1 px-xxl-3 py-2 border border-secondary text-light bg-myblue">
                            Files Uploaded
                          </button>
                          <button
                            style={{ color: "#005E9D" }}
                            className="d-block bs-lh px-xl-1 px-xxl-3 py-2 border border-secondary "
                          >
                            Pending Edits
                          </button>
                          <button
                            style={{ color: "#005E9D" }}
                            className="d-block bs-lh px-xl-1 px-xxl-3 py-2 border border-secondary  bg-white"
                          >
                            Sent for Approval
                          </button>
                          <button
                            style={{ color: "#005E9D" }}
                            className="d-block bs-lh px-xl-1 px-xxl-3 py-2 border border-secondary  bg-white"
                          >
                            Approved!
                          </button>

                          <button
                            style={{ color: "#005E9D" }}
                            className="d-block bs-lh px-xl-1 px-xxl-3 py-2 border border-secondary  bg-white"
                          >
                            Printing
                          </button>
                          <button
                            style={{ color: "#005E9D" }}
                            className="d-block bs-lh px-xl-1 px-xxl-3 py-2 border border-secondary  bg-white"
                          >
                            Shipped
                          </button>
                          <button
                            style={{ color: "#005E9D" }}
                            className="d-block bs-lh px-xl-1 px-xxl-3 py-2 border border-secondary  bg-white"
                          >
                            Awaiting install
                          </button>

                          <button
                            style={{ color: "#005E9D" }}
                            className="d-block bs-lh px-xl-1 px-xxl-3 py-2 border border-secondary  bg-white"
                          >
                            Campaign Launched!
                          </button>
                        </div>
                        <p className="mt-1 text-center blue-txt">
                          Need creative approval by{" "}
                          <span className="text-danger">01/10/2023</span> for on
                          time launch!
                        </p>
                        {/* -------upload-btn------- */}
                        <div className=" mx-auto col-sm-9 col-md-4 col-lg-3">
                          <div>
                            <button className="w-100 mt-3 border border-secondary rounded-3 py-1 px-2 corporate-upload">
                              <input
                                type="file"
                                id="upload-f"
                                className="d-none"
                              />
                              <label htmlFor="upload-f">
                                <img
                                  src={require("../../assets/img/upload-img.png")}
                                  alt=""
                                  className="h-100"
                                />
                              </label>
                              <p className="mt-1 text-secondary">
                                Upload files here
                              </p>
                            </button>
                          </div>
                          <div className=" other-btns d-flex align-items-center justify-content-center mt-1">
                            <button className="border-0 text-light py-2 px-3 text-uppercase me-2 bs-lh mt-1">
                              Proof sheet
                            </button>
                            <button className="border-0 text-light py-2 px-3 text-uppercase edit-btn">
                              <img
                                src={require("../../assets/img/edit-img.png")}
                                alt=""
                              />
                            </button>
                          </div>
                          <span className="ms-2 mb-1 blue-txt bs-lh fs_14px pt-4">
                            Approved On 01/08/2023
                          </span>
                        </div>
                        {/* --------other-btns------ */}
                        {/* <div className=" mt-2 d-flex flex-wrap justify-content-end pe-5 other-btns w-75 mx-auto">
                          <div className=" d-flex align-items-center justify-content-end mt-1"></div>
                        </div> */}
                      </div>
                    )}
                  </div>
                  {/* =============Campaign overview==============*/}
                  <div className="mt-2">
                    <div className="d-flex align-items-center justify-content-between ">
                      <div />
                      <h4 className="blue-txt text-center position-relative prod-head">
                        Campaign overview
                      </h4>

                      <div>
                        {!data.section2 ? (
                          <MdExpandMore
                            size={40}
                            onClick={() => handleChange("section2", true)}
                          />
                        ) : (
                          <MdExpandLess
                            size={40}
                            onClick={() => handleChange("section2", false)}
                          />
                        )}
                      </div>
                    </div>
                    {data.section2 && (
                      <div className="row comp-main">
                        <div className="col-lg-6 pe-lg-2">
                          <div
                            className="px-2 py-3 comp-box border border-secondary rounded-3 my-3 pe-2"
                            style={{ height: "280px" }}
                          >
                            <h4 className="text-secondary overview-head position-relative fw-bolder">
                              Campaign Details
                            </h4>
                            <p className="bs-lh my-2 text-secondary mt-3">
                              <span className="fw-bolder">Start Date: </span>{" "}
                              08/22/2022
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">End Date: </span>{" "}
                              03/10/2023
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">
                                Vehicle Impressions:{" "}
                              </span>
                              981,241 Impressions
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">Coverage Area: </span>
                              portland,Oregon
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">Hours Driven: </span>
                              120 hours driven
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">Coverage Area: </span>
                              7000 miles
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6 ps-lg-2">
                          <div className="px-2 py-3 comp-box border border-secondary rounded-3 my-3">
                            <h4 className="text-secondary overview-head position-relative fw-bolder">
                              Campaign Goal
                            </h4>
                            <p className="bs-lh my-2 text-secondary mt-3">
                              <span className="fw-bolder">Goal: </span>Increase
                              customer click on website link.
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">Target Age: </span> 25
                              - 35 years old
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">Target Gender: </span>
                              Male-60% ; Female-40%
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">Income level: </span>
                              ~$70,000/year
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">
                                Target Ethncity:{" "}
                              </span>
                              Hispanic ; White
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">Behavioral: </span>
                              Movie lovers ; Sports fans/watchers
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6 pe-lg-2">
                          <div
                            className="px-2 py-3 comp-box border border-secondary rounded-3 my-3"
                            style={{ height: "260px" }}
                          >
                            <h4 className="text-secondary overview-head position-relative fw-bolder">
                              Retargeting Data
                            </h4>
                            {/* <p className="bs-lh my-2 text-secondary mt-3"><span className="fw-bolder">Goal: </span>Increase customer click
                    on website link.</p> */}
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">
                                Retargeting Impressions:
                              </span>
                              435,783
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">Total Clicks: </span>
                              58,234
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">
                                Click through Rate (CTR):{" "}
                              </span>
                              13%
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">
                                Cost Per Impressions (thousand):
                              </span>
                              $0.35
                            </p>
                            <p className="bs-lh my-2 text-secondary">
                              <span className="fw-bolder">
                                Retargeting URL:
                              </span>
                              Https://spotkeep.com
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6 ps-lg-2">
                          <div className="px-2 py-3 comp-box border border-secondary rounded-3 my-3">
                            <h4 className="text-secondary overview-head position-relative fw-bolder">
                              Heat Map
                            </h4>
                            <div className="heat-map mt-3">
                              <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3366.1665067871677!2d74.51240541451907!3d32.46823790697378!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391eebf05050a257%3A0x65c6ed11df82a794!2sFabulous%20Technology%20Solutions!5e0!3m2!1sen!2s!4v1674730889509!5m2!1sen!2s"
                                width="100%"
                                height="176px"
                                style={{ border: 0 }}
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* ===============Graphs===============*/}
                  <div className="d-flex align-items-center justify-content-between ">
                    <div />
                    <h4 className="blue-txt text-center position-relative prod-head">
                      Campaign Performance
                    </h4>

                    <div>
                      {!data.section3 ? (
                        <MdExpandMore
                          size={40}
                          onClick={() => handleChange("section3", true)}
                        />
                      ) : (
                        <MdExpandLess
                          size={40}
                          onClick={() => handleChange("section3", false)}
                        />
                      )}
                    </div>
                  </div>
                  {data.section3 && (
                    <div className="container">
                      <div className="row mt-3">
                        <div className="col-md-6">
                          <div
                            className="chart_border"
                            style={{ overflow: "hidden" }}
                          >
                            <AdvertiserBarImpression />
                            {/* <img src={require("../../assets/img/chart_img_1.png")} className="chart_img_border" width="100%" alt="" /> */}
                          </div>
                        </div>
                        <div className="col-md-6 px-2 mb-3">
                          <div
                            className="chart_border"
                            style={{ overflow: "hidden" }}
                          >
                            <AdvertiserBarMiles />
                            {/* <img src={require("../../assets/img/chart_img_2.png")} className="chart_img_border" width="100%" alt="" /> */}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className=" col-md-6 mb-3">
                          <div className="p-2 chart_border">
                            <AdvertiserDonutEthnicities />
                            {/* <img src={require("../../assets/img/chart_img_3.png")} className="chart_img_border" width="100%" alt="" /> */}
                          </div>
                        </div>
                        <div className=" col-md-6 px-2 mb-3">
                          <div className="p-2 chart_border">
                            <AdvertiserDonutIncomeLevel />
                            {/* <img src={require("../../assets/img/chart_img_4.png")} className="chart_img_border" width="100%" alt="" /> */}
                          </div>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-md-6 px-2 mb-3">
                          <div
                            className="chart_border"
                            style={{ overflow: "hidden", height: "305px" }}
                          >
                            <AdvertiserBarBehavioral />
                            {/* <img src={require("../../assets/img/chart_img_5.png")} className="chart_img_border" width="100%" alt="" /> */}
                          </div>
                        </div>
                        <div className="col-md-6 px-2 mb-3">
                          <div className="chart_border ps-md-0 ps-2">
                            <div className="my-2 ps-3">
                              <h5 className="fw-bold">Vehicle Type</h5>
                            </div>
                            <div className="d-flex offset-lg-3 offset-md-2  gap-2 mb-2">
                              <div className="V_T_number">
                                <h5 style={{ fontSize: "12px" }}>
                                  <b className="fs-4">3</b>Qty.
                                </h5>
                              </div>
                              <div className="d-flex px-2 car_tect_width">
                                <div className="my-auto car_h_v">
                                  <img
                                    src={require("../../assets/img/car_icon.png")}
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className="my-auto px-3 fs_10px">
                                  <h5 style={{ fontSize: "12px" }}>
                                    Ride-Share Car
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex offset-lg-3 offset-md-2 gap-2 mb-2">
                              <div className="V_T_number">
                                <h5 style={{ fontSize: "12px" }}>
                                  <b className="fs-4">12</b>Qty.
                                </h5>
                              </div>
                              <div className="d-flex px-2 car_tect_width">
                                <div className="my-auto car_h_v_t">
                                  <img
                                    src={require("../../assets/img/boc_truck.png")}
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className="my-auto px-3">
                                  <h5 style={{ fontSize: "12px" }}>
                                    Box Truck
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex offset-lg-3 offset-md-2 gap-2 mb-2">
                              <div className="V_T_number">
                                <h5 style={{ fontSize: "12px" }}>
                                  <b className="fs-4">2</b>Qty.
                                </h5>
                              </div>
                              <div className="d-flex px-2 car_tect_width">
                                <div className=" car_h_v_t_2">
                                  <img 
                                    src={require("../../assets/img/sami_truck.png")}
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className=" my-auto px-2 ">
                                  <h5 className="" style={{ fontSize: "12px" }}>
                                    Semi-Truck
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex offset-lg-3 offset-md-2 gap-2 mb-2">
                              <div className="V_T_number">
                                <h5 style={{ fontSize: "12px" }}>
                                  <b className="fs-4">2</b>Qty.
                                </h5>
                              </div>
                              <div className="d-flex px-2 car_tect_width">
                                <div className="my-auto car_h_v">
                                  <img
                                    src={require("../../assets/img/led_truck.png")}
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className="my-auto px-3">
                                  <h5 style={{ fontSize: "12px" }}>
                                    LED Truck
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex offset-lg-3 offset-md-2 gap-2 mb-2">
                              <div className="V_T_number">
                                <h5 style={{ fontSize: "12px" }}>
                                  <b className="fs-4">1</b>Qty.
                                </h5>
                              </div>
                              <div className="d-flex px-2 car_tect_width">
                                <div className="my-auto car_h_v">
                                  <img
                                    src={require("../../assets/img/skinny_truck.png")}
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className="my-auto px-3">
                                  <h5 style={{ fontSize: "12px" }}>
                                    Skinny Truck
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* ==========campaign photos and reports======== */}
                  <div className="mt-2">
                    <div className="d-flex align-items-center justify-content-between">
                      <div />
                      <h4 className="blue-txt text-center position-relative prod-head">
                        Campaign Photos and Reports
                      </h4>
                      <div>
                        {!data.section4 ? (
                          <MdExpandMore
                            size={40}
                            onClick={() => handleChange("section4", true)}
                          />
                        ) : (
                          <MdExpandLess
                            size={40}
                            onClick={() => handleChange("section4", false)}
                          />
                        )}
                      </div>
                    </div>
                    {/* -----photos and reports-main---- */}
                    {data.section4 && (
                      <div className="row">
                        {/* ---col-1--- */}
                        <div className="col-lg-6 pe-lg-2">
                          <div
                            className="mt-2 bg-white rounded-3 border border-secondary px-3 py-2"
                            style={{ height: "208px" }}
                          >
                            {/* -------upload-btn------- */}
                            <div>
                              <h6 className="text-secondary fw-bolder text-center position-relative overview-head pr-head">
                                Campaign Photos and Reports
                              </h6>
                              <button className="w-100 mt-3 border border-secondary rounded-3 py-1 px-2 corporate-upload">
                                <label htmlFor="upload-f d-block mt-3">
                                  <i className="fas fa-images lead text-secondary" />
                                </label>
                                <span>
                                  <i class="bi bi-camera-fill"></i>
                                </span>
                                <p className="mt-1 text-secondary">
                                  Preview Photos{" "}
                                </p>
                              </button>
                              <p className="blue-txt text-center mt-2">OR</p>
                            </div>
                            {/* --------other-btns------ */}
                            <div className="mt-2 d-flex justify-content-center other-btns">
                              <button className="border-0 text-light py-3 px-3 text-uppercase me-2 rounded-3">
                                Download
                              </button>
                            </div>
                          </div>
                        </div>
                        {/* ---col-2---- */}
                        <div className="col-lg-6 ps-lg-2">
                          <div className="d-flex mt-2 bg-white rounded-3 border border-secondary px-3 py-2">
                            {/* --------current-report---- */}
                            <div className="me-2">
                              <h6 className="text-secondary fw-bolder text-center position-relative overview-head pr-head">
                                Current Report
                              </h6>
                              <button className="w-100 mt-2 border border-secondary rounded-3 py-2 px-2 corporate-upload">
                                <div>
                                  <img
                                    src={require("../../assets/img/report.png")}
                                    alt=""
                                    className="crnt-img"
                                  />
                                </div>
                                <p
                                  className="mt-3 fw-bold text-secondary"
                                  style={{ fontSize: "12px" }}
                                >
                                  Report: 01/05/2023
                                </p>
                              </button>
                              <div className="mt-2 d-flex justify-content-center other-btns">
                                <button
                                  className="border-0 text-light py-3 px-3 text-uppercase me-2 rounded-3"
                                  style={{ fontSize: "12px" }}
                                >
                                  Download Report
                                </button>
                              </div>
                            </div>
                            {/* ------previous-report------- */}
                            <div>
                              <h6 className="text-secondary fw-bolder text-center position-relative overview-head pr-head">
                                Previous Report
                              </h6>
                              {/* -----previous-report-1-- */}
                              <div className="d-flex mt-2">
                                <button className="border border-secondary rounded-3 py-1 px-2 corporate-upload me-1">
                                  <div>
                                    <img
                                      src={require("../../assets/img/report.png")}
                                      alt=""
                                      className="prev-r-img"
                                    />
                                  </div>
                                  <p
                                    className="mt-1 fw-bold text-secondary"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Report: 01/05/2023
                                  </p>
                                </button>
                                <button className="border border-secondary rounded-3 py-2 px-2">
                                  <FaDownload />
                                </button>
                              </div>
                              <div className="d-flex mt-2">
                                <button className="border border-secondary rounded-3 py-1 px-2 corporate-upload me-1">
                                  <div>
                                    <img
                                      src={require("../../assets/img/report.png")}
                                      alt=""
                                      className="prev-r-img"
                                    />
                                  </div>
                                  <p
                                    className="mt-1 fw-bold text-secondary"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Report: 01/05/2023
                                  </p>
                                </button>
                                <button className="border border-secondary rounded-3 py-2 px-2">
                                  <FaDownload />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* ===============Campaign requests===============*/}
                  <div className="mt-2">
                    <div className="d-flex align-items-center justify-content-between">
                      <div />
                      <h4 className="blue-txt text-center position-relative prod-head">
                        Campaign requests
                      </h4>
                      <div>
                        {!data.section5 ? (
                          <MdExpandMore
                            size={40}
                            onClick={() => handleChange("section5", true)}
                          />
                        ) : (
                          <MdExpandLess
                            size={40}
                            onClick={() => handleChange("section5", false)}
                          />
                        )}
                      </div>
                    </div>
                    {/* ----------Request textarea--------- */}
                    <section className="req-sec main-sec ">
                      {data.section5 && (
                        <div className="d-lg-flex justify-content-between make_res mt-3">
                          <div className="req-field d-sm-flex w-100 ">
                            <div className="req-btn px-2">
                              <div className="dropdown">
                                <button
                                  className="btn btn-secondary shadow-none dropdown-toggle text-secondary"
                                  type="button"
                                  id="dropdownMenuButton1"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  style={{
                                    backgroundColor: "#CEDDE5",
                                  }}
                                >
                                  {compaignType}
                                </button>
                                <ul
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton1"
                                >
                                  <li className="px-2"
                                    onClick={() =>
                                      handlecomapignType("Ceative")
                                    }
                                  >
                                    <a className="dropdown-item d-flex gap-1" href="#">
                                      <div style={{width:"20px"}}>
                                      <img width={"100%"}
                                        src={require("../../assets/img/brush.png")}
                                        // width={25}
                                        alt=""
                                        className="img-fluid "
                                      />
                                      </div>
                                      Creative
                                    </a>
                                  </li>
                                  <li
                                    onClick={() =>
                                      handlecomapignType("Retargeting")
                                    }
                                  >
                                    <a className="dropdown-item " href="#">
                                      <img
                                        src={require("../../assets/img/retargeting.png")}
                                        alt=""
                                        
                                        className="img-fluid pe-2"
                                      />
                                      Retargeting
                                    </a>
                                  </li>
                                  <li
                                    onClick={() =>
                                      handlecomapignType("Extension")
                                    }
                                  >
                                    <a className="dropdown-item " href="#">
                                      <img
                                        src={require("../../assets/img/repair.png")}
                                        alt=""
                                        className="img-fluid pe-2"
                                      />
                                      Extension
                                    </a>
                                  </li>
                                  <li
                                    onClick={() =>
                                      handlecomapignType("Photoshoot")
                                    }
                                  >
                                    <a className="dropdown-item ms-1" href="#">
                                      <img
                                        src={require("../../assets/img/camera-icon.png")}
                                        alt=""
                                        className="img-fluid pe-2"
                                      />
                                      Photoshoot
                                    </a>
                                  </li>
                                  <li
                                    onClick={() => handlecomapignType("Swarm")}
                                  >
                                    <a className="dropdown-item  " href="#">
                                      <img
                                        src={require("../../assets/img/swarm.png")}
                                        alt=""
                                        className="img-fluid pe-2 pe-2"
                                      />
                                      Swarm
                                    </a>
                                  </li>
                                  <li className="ps-1"
                                    onClick={() =>
                                      handlecomapignType("Special Events")
                                    }
                                  >
                                    <a
                                      className="dropdown-item  "
                                      href="#"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <i
                                        className="bi bi-balloon-heart-fill "
                                        style={{
                                          fontSize: "22px",
                                          color: "black",
                                        }}
                                      ></i>
                                      <span>Special Events</span>
                                    </a>
                                  </li>
                                  <li
                                    onClick={() =>
                                      handlecomapignType("New Campaign")
                                    }
                                  >
                                    <a className="dropdown-item ms-1 " href="#">
                                      <FaTruckMoving size={30} />
                                      <span className="ps-1">
                                      New Campaign
                                      </span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className=" d-flex px-1 align-items-center blue-txt w-100 bg-white req-fix">
                              <div className="pe-2  position-relative req-text">
                                <textarea
                                  name
                                  onChange={(e) =>
                                    handleMessage("message", e.target.value)
                                  }
                                  id="message"
                                  className="align-items-center w-100 "
                                  placeholder="Type your message to Rolling Adz here..."
                                  style={{ border: "none" }}
                                />
                              </div>
                              <div className="d-flex align-items-center ps-2 req-link">
                                <p className="blue-txt bs-lh my-auto">
                                  Attach File
                                </p>

                                <i class="bi bi-file-earmark-text-fill fs-2"></i>
                              </div>
                            </div>
                          </div>
                          <div className="ms-2  d-flex justify-content-end req-btns mt-3 mt-md-0 pad">
                            <a
                              href="#"
                              type="submit"
                              className="d-flex align-items-center px-3 blue-txt bg-white text-center"
                            >
                              Send Message
                            </a>
                          </div>
                        </div>
                      )}
                    </section>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
